export const BILLING_EMBED_PATH = '/admin-embed/billing';
